import React, { useEffect, useState, useCallback } from 'react';
import './FileUploadField.scss';
import 'react-dropzone-uploader/dist/styles.css'
import Dropzone from 'react-dropzone-uploader'
import Hint from "../Hint/Hint";
import { useFormContext } from "react-hook-form";
import FieldErrorMessage from "../FieldErrorMessage";

const FileUploadField = ( { isVisible = [], changeState = null, id, hint = '', name, isRequired = false } ) => {
    const [arrFiles, setArrFiles] = useState( [] );
    const [clear, setClear] = useState( true );
    const [fullCont, setFullCont] = useState( false );
    const { register, setValue, trigger } = useFormContext();

    var fileArr = []

  function fileSizeValidator(file) {
    const image_limit_size = 25;
    const video_limit_size = 200;
    if (file.meta.type === 'video/mp4' && file.meta.size > video_limit_size * 1024 * 1024) {
        return `Video limited to ${video_limit_size}MB`;
    }
    else if (file.meta.type === 'video/mp4' && fileArr.some(file_object => file_object.meta.type === 'video/mp4' && file_object.meta.status === 'done')) {
        return `Only one video file can be uploaded`;
    }
    else if (file.meta.type.startsWith("image/") && file.meta.size > image_limit_size * 1024 * 1024) {
        return `Image limited to ${image_limit_size}MB`;
    }
    return false;
  }

    const handleChangeStatus = ({ meta, file }, status, files) => {
        const processFiles = async () => {
            if (status === 'done' || status === 'removed') {
                const newFiles = await handleFileRead(status === 'removed'
                    ? files.filter(f => f.file.name !== file.name)
                    : files);

                setArrFiles(newFiles);
                setValue(name, newFiles);
                trigger(name);
            }
        };
        processFiles();
        fileArr = files;

        setFullCont(files.length === 4);
    };

    const showPopup = () => {
        const newArr = [...isVisible];
        newArr[id] = true;
        changeState( newArr )
        setClear( true );
    }
    const convertBase64 = useCallback(async (files) => {
        return Promise.all(
            files.map(f => new Promise((resolve) => {
                const fileReader = new FileReader();
                fileReader.readAsDataURL(f.file);
                fileReader.onload = () => resolve({
                    fileB64: fileReader.result,
                    meta: f.meta
                });
            }))
        );
    }, []);

    const handleFileRead = useCallback(async (files) => {
        return await convertBase64(files);
    }, [convertBase64]);

    const hidePopup = () => {
        const newArr = [...isVisible];
        newArr[id] = false;
        changeState( newArr );
    }

    const clearField = () => {
        setClear( false );
        setArrFiles( [] );
    }



    useEffect(() => {
        register(name, {
            required: isRequired ? "This field is required" : false,
            validate: (value) => {
                return !isRequired || (value?.length > 0);
            }
        });
    }, [register, name, isRequired]);

    useEffect(() => {
        setValue(name, arrFiles);
        trigger(name);
    }, [arrFiles, setValue, name, trigger]);

    return (
        <div className="file-upload-field">
            <div className="file-upload-field__title">Upload photo/video {isRequired && <span className="required">*</span>}{hint && <Hint hint={hint}/>}</div>
            <div className="file-upload-field__btn" onClick={showPopup}>Browse</div>
            {arrFiles.length ? <div className="file-upload-field__total-file">{arrFiles.length} files added</div> : ''}
            {arrFiles.length ? <div className="file-upload-field__clear-field" onClick={clearField}/> : ''}
            <div className={`file-upload-field__popup ${isVisible[id] ? 'show' : ''}`}>
                <div className="file-upload-field__card">
                    <div className={`file-upload-field__close`} onClick={hidePopup}/>
                    {arrFiles.length ?
                        <div className={`file-upload-field__message`}>File uploaded! Please add more files or close
                            this window.</div> : ''}
                    {clear ? <Dropzone
                        validate={fileSizeValidator}
                        inputContent={'Drop files here'}
                        onChangeStatus={handleChangeStatus}
                        accept="image/png,image/gif,image/jpeg,video/mp4,application/pdf"
                        maxFiles={4}
                    /> : ''}
                    {fullCont ? <div className={`file-upload-field__quantity-limitation`}>Item limit is 4.</div> : ''}
                </div>
                <div className="file-upload-field__bg"/>
            </div>
            <FieldErrorMessage name={name} />
        </div>
    )
};
export default FileUploadField;
